

const tabStyle = { paddingLeft: "20px", paddingRight: "20px", paddingTop: "10px", paddingBottom: "10px", borderTopLeftRadius: "5px", borderTopRightRadius: "5px" };
const tabPointerStyle = { cursor: "pointer", paddingLeft: "20px", paddingRight: "20px", paddingTop: "10px", paddingBottom: "10px", borderTopLeftRadius: "5px", borderTopRightRadius: "5px" };

const ProjectTab = (step: number, nextStep: boolean, handleDoc: Function | null,handleProject: Function | null,handleProjectGroup: Function | null) => {
    return (<div className="row" style={{ justifyContent: "left", paddingLeft: "40px" }}>
        <div className={(step === 3) ? "yellow-button" : "yellow-secondary-button"} style={(handleProjectGroup == null) ? tabStyle : tabPointerStyle} onClick={e => ((handleProjectGroup != null) ? handleProjectGroup() : () => { })}>
            <b>กลุ่มโครงการ</b>
        </div>&nbsp;
        <div className={(step === 1) ? "yellow-button" : "yellow-secondary-button"} style={(handleProject == null) ? tabStyle : tabPointerStyle} onClick={e => ((handleProject != null) ? handleProject() : () => { })}>
            <b>ข้อมูลโครงการ</b>
        </div>&nbsp;
        <div className={(step === 2) ? "yellow-button" : "yellow-secondary-button"} style={(handleDoc == null) ? tabStyle : tabPointerStyle} onClick={e => ((handleDoc != null) ? handleDoc() : () => { })}>
            <b>เอกสารการเรียน</b>
        </div>
        
    </div>);
}

export default ProjectTab;
